import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Menu } from '../model/menu';
import { AbsorcionesGrupo } from '../model/absorciones-grupo';
import { IPagination } from '../model/pagination';

@Injectable({
  providedIn: 'root'
})
export class AbsorcionGrupoService {
  PATH = environment.API_BASE + '/Inventario/AbsorberGruposExpedientes';

  constructor(
    private http: HttpClient
  ) { }

  absorbGroup(absorbGroupId: number, targetGroupId: number, clientId: number): Observable<number> {
    return this.http.post<any>(this.PATH, { AbsorbGroupId: absorbGroupId, TargetGroupId: targetGroupId, ClientId: clientId })
      .pipe(map(success => {
        return success;
      }));
  }

  getAllAbsorptions(clientId: number, inicio: number, fin: number): Observable<IPagination<AbsorcionesGrupo>> {
    const observable =  this.http.get(this.PATH + '/' + clientId + '/' + inicio + '/' + fin)
      .pipe(map((data: IPagination<AbsorcionesGrupo>) =>
        IPagination.toModel<AbsorcionesGrupo>(JSON.stringify(data), AbsorcionesGrupo)));
    return observable as Observable<IPagination<AbsorcionesGrupo>>;
  }

  deleteAbsorption(clientId: number) {
    return this.http.delete(this.PATH + '/' + clientId)
      .pipe(map(success => success));
  }
}
